module.exports = __webpack_public_path__ + "static/media/ico_intergrate_o.13c83f89.svg";